module.exports = __webpack_public_path__ + "img/d56451459590ad6fe66e5a620db40113.d5645145.png";